import { useState, useEffect } from 'react'
import { UserPreferencesContext } from './user-preferences-context'
import { useCurrentUser } from '~/common/use-current-user'

export const UserPreferencesContextProvider = ({ children }) => {
  const { userPreferences: fetchedPreferences } = useCurrentUser()
  const [userPreferences, setUserPreferences] = useState({})

  useEffect(() => {
    function syncPreferences() {
      if (!fetchedPreferences || Object.keys(fetchedPreferences).length === 0) return
      setUserPreferences(fetchedPreferences)
    }
    syncPreferences()
  }, [fetchedPreferences])

  return (
    <UserPreferencesContext.Provider value={{ userPreferences, setUserPreferences }}>
      {children}
    </UserPreferencesContext.Provider>
  )
}
